import { render, staticRenderFns } from "./ModalCustomers.vue?vue&type=template&id=1df35eaa&scoped=true&lang=pug&"
import script from "./ModalCustomers.vue?vue&type=script&lang=js&"
export * from "./ModalCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ModalCustomers.vue?vue&type=style&index=0&id=1df35eaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1df35eaa",
  null
  
)

export default component.exports